<script>
import MixedGridFiltersSelected from '@phoenix/mixins/components/mixedGrid/MixedGridFiltersSelected';
import { PhxIcon } from '@phx-styleguides/pia';
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';

export default {
  components: { PhxIcon, PhxsgButton },

  mixins: [MixedGridFiltersSelected],

  props: {
    hideReset: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['removeFilter', 'removeAllFilters'],
};
</script>

<template>
  <ul v-if="hasFilters" class="list list--inline list--tight list--gap-xs" data-cy="active-filters">
    <template v-for="(groupedFilters, filterId) in activeFilters" :key="filterId">
      <li v-if="isSellable(filterId)">
        <button
          class="btn btn--primary btn--xs btn--filters"
          type="button"
          :aria-label="$t('Search.RemoveFilter')"
          @click="$emit('removeFilter', filterId)"
        >
          {{ $t('ProductProperty.SHOW.AVAILABLE FOR PURCHASE') }}
          <span class="btn__icon btn__icon--end">
            <phx-icon icon="close" class="icon--2xs" />
          </span>
        </button>
      </li>

      <li v-else-if="isRange(filterId)">
        <button
          class="btn btn--primary btn--xs btn--filters"
          type="button"
          :aria-label="$t('Search.RemoveFilter')"
          @click="$emit('removeFilter', filterId)"
        >
          {{ getFilterById(filterId).label }}
          <span class="btn__icon btn__icon--end">
            <phx-icon icon="close" class="icon--2xs" />
          </span>
        </button>
      </li>

      <template v-else>
        <li v-for="value in groupedFilters" :key="value">
          <button
            class="btn btn--primary btn--xs btn--filters"
            type="button"
            :aria-label="$t('Search.RemoveFilter')"
            @click="$emit('removeFilter', filterId, value)"
          >
            {{ getFilterItemFromIdAndValue(filters, filterId, value).label }}
            <span class="btn__icon btn__icon--end">
              <phx-icon icon="close" class="icon--2xs" />
            </span>
          </button>
        </li>
      </template>
    </template>

    <template v-if="!hideReset">
      <li v-show="hasFilters">
        <PhxsgButton
          variant="link"
          :aria-label="$t('Search.ResetAll')"
          data-cy="clear-filters-btn"
          @click="$emit('removeAllFilters')"
        >
          {{ $t('Search.ResetAll') }}
        </PhxsgButton>
      </li>
    </template>
  </ul>
</template>
